/* eslint-disable func-names */
/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Drawer, makeStyles, Pagination, Paper } from "@mui/material";
import Modal from "@mui/material/Modal";
import { Context } from "context/Context";
import { converterObjetoParaString } from "hooks/convertObjectToString";
import React, { useCallback, useEffect, useState } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { useListarAtendimentos } from "services/api/AppWeb_Atendimento";
import { AuthState } from "store/ducks/auth/types";
import Skeleton from "@mui/material/Skeleton";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { usePlantaoVendas } from "contexts/PlantaoVendasContext";
import { GrStatusDisabledSmall } from "react-icons/gr";
import FilterButton from "./components/FilterButton";
import Filters from "./components/Filters";
import FormNovoAtendimento from "./components/FormNovoAtendimento";
import GradientButton from "./components/GradientButton";
import Message from "./components/Message/message.component";
import TableItem from "./components/TableItem";
// import { atendimentos } from "./fakeData";
import * as Styles from "./styles";
import useRepetirComponente from "../../../../hooks/useRepetirComponente";
import ButtonClearFilter from "./components/ButtonClearFilter";

interface AnyObject {
  [key: string]: any;
}

const theme = createTheme({
  components: {
    MuiPagination: {
      styleOverrides: {
        ul: {
          "& .Mui-selected": {
            backgroundColor: "#2d5bff !important", // Cor do item selecionado
            color: "#ffffff", // Cor do texto do item selecionado
            border: "none",
            "&:hover": {
              backgroundColor: "#2d5bff", // Cor do item selecionado no hover
            },
          },
          "& button:not(.Mui-selected)": {
            backgroundColor: "#d5deff", // Cor dos demais itens
            color: "#2d5bff", // Cor do texto dos demais itens
            border: "none",
            "&:hover": {
              backgroundColor: "#d5deff", // Cor do item selecionado no hover
            },
          },
        },
      },
    },
  },
});

interface Props {
  onChangeFiltrosIndicadores: (item: any) => void;
}

const completedCalls: React.FC<Props> = (props) => {
  const [openFilters, setOpenFilters] = React.useState(false);
  const [openNewCall, setOpenNewCall] = React.useState(false);
  const { filtersPDV, setFiltersPDV } = React.useContext(Context);
  const [filtros, setFiltros] = useState<any>(null);
  const { plantaoVendas, codigoCargo2013, supervisorProduto } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  const { plantaoVendas: pdvSelected } = usePlantaoVendas();
  const {
    data: dataAtendimentos,
    refetch: refetchAtendimentos,
    isFetching: isLoadingAtendimentos,
    isFetched,
    isSuccess,
  } = useListarAtendimentos({
    queryKey: "antendimentos",
    idLocalVendas: supervisorProduto
      ? pdvSelected?.value || "idLocalVendas=null"
      : plantaoVendas?.id,
    params:
      filtros === null
        ? converterObjetoParaString({ PaginaAtual: 1, TotalItensRetorno: 25 })
        : converterObjetoParaString(filtros),
  });
  const [atendimentos, setAtendimentos] = useState<any[]>([]);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);

  useEffect(() => {
    if (!pdvSelected && supervisorProduto) {
      setAtendimentos([]);
      setPaginaAtual(1);
      setTotalPaginas(1);
      return;
    }

    if (dataAtendimentos && Array.isArray(dataAtendimentos.data)) {
      setAtendimentos(dataAtendimentos.data);
      setPaginaAtual(dataAtendimentos.pagination?.currentPage || 1);
      setTotalPaginas(dataAtendimentos.pagination?.quantityPages || 1);
    } else {
      setAtendimentos([]);
      setPaginaAtual(1);
      setTotalPaginas(1);
    }
  }, [dataAtendimentos, pdvSelected]);

  useEffect(() => {
    if (supervisorProduto && !pdvSelected?.value) {
      return;
    }
    handleRefetch();
  }, [filtros, pdvSelected]);

  useEffect(() => {
    getFilter();
  }, []);

  useEffect(() => {
    console.log("pdvSelected: ", pdvSelected);
    console.log("supervisor: ", supervisorProduto);
  }, [pdvSelected, supervisorProduto]);

  const handleRefetch = async () => {
    await refetchAtendimentos();
    setOpenFilters(false);
  };

  function transformObject(obj: AnyObject): AnyObject {
    const transformedObj: AnyObject = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const fieldValue = obj[key];

        if (fieldValue && typeof fieldValue === "object") {
          if ("value" in fieldValue) {
            transformedObj[key] = fieldValue.value;
          } else if (key === "Periodo") {
            // Trata o objeto Periodo separadamente
            if (fieldValue.PeriodoDe)
              transformedObj.PeriodoDe = fieldValue.PeriodoDe;
            if (fieldValue.PeriodoAte)
              transformedObj.PeriodoAte = fieldValue.PeriodoAte;
          } else if (key === "paginationParams") {
            // Trata o objeto paginationParams separadamente
            if (fieldValue.PaginaAtual)
              transformedObj.PaginaAtual = fieldValue.PaginaAtual;
            if (fieldValue.TotalItensRetorno)
              transformedObj.TotalItensRetorno = fieldValue.TotalItensRetorno;
            if (fieldValue.PalavrasChave)
              transformedObj.PalavrasChave = fieldValue.PalavrasChave;
            if (fieldValue.OrdenarPorOrdemAlfabetica)
              transformedObj.OrdenarPorOrdemAlfabetica =
                fieldValue.OrdenarPorOrdemAlfabetica;
          } else {
            transformedObj[key] = fieldValue;
          }
        } else {
          transformedObj[key] = fieldValue;
        }
      }
    }

    return transformedObj;
  }

  const handleGetFilter = async (item: any) => {
    item.PaginaAtual = 1;
    item.TotalItensRetorno = 25;
    setFiltros(transformObject(item));
    props.onChangeFiltrosIndicadores(transformObject(item));
  };

  const getFilter = async () => {
    const filtross: any = await localStorage.getItem("@sell.it/PDVFilters");
    const filtros2Json = JSON.parse(filtross);
    filtros2Json.PaginaAtual = paginaAtual;
    filtros2Json.TotalItensRetorno = 25;
    if (filtros2Json) {
      setFiltros(transformObject(filtros2Json));
      props.onChangeFiltrosIndicadores(transformObject(filtros2Json));
    }
  };

  const handlePageChange = (event: any, page: number) => {
    setPaginaAtual(page);
  };

  const getNextPage = async () => {
    const filtross: any = await localStorage.getItem("@sell.it/PDVFilters");
    const filtros2Json = JSON.parse(filtross);
    filtros2Json.PaginaAtual = paginaAtual;
    filtros2Json.TotalItensRetorno = 25;
    if (filtros2Json) {
      setFiltros(transformObject(filtros2Json));
    }
  };

  useEffect(() => {
    getNextPage();
  }, [paginaAtual]);

  function contarFiltros() {
    if (filtros === null || filtros === undefined) {
      return 0;
    }

    let contador = 0;
    const camposIgnorados = [
      "PeriodoAte",
      "TotalItensRetorno",
      "PaginaAtual",
      "Periodo",
      "paginationParams",
    ];

    for (const chave in filtros) {
      if (
        filtros.hasOwnProperty(chave) &&
        filtros[chave] !== "" &&
        filtros[chave] !== null &&
        filtros[chave] !== undefined &&
        !camposIgnorados.includes(chave)
      ) {
        contador++;
      }
    }

    return contador;
  }

  const totalFiltros = contarFiltros();

  const clearFilter = () => {
    setFiltersPDV({
      ...filtersPDV,
      Visitante: null,
      Corretor: null,
      TipoDeVisita: null,
      EmpresaDeVendas: null,
      Equipe: null,
      PeriodoDe: null,
      PeriodoAte: null,
    });
    handleRefetchAtendimentos();
  };

  const handleRefetchAtendimentos = () => {
    getFilter();
  };

  return (
    <Styles.Container>
      <Styles.RowSpace>
        <Styles.Title>Atendimentos concluídos</Styles.Title>
        <Styles.RowAlign>
          <GradientButton
            disabled={supervisorProduto && !pdvSelected}
            onClick={() => setOpenNewCall(!openFilters)}
          />
          <ButtonClearFilter
            disabled={supervisorProduto && !pdvSelected}
            badgeCount={totalFiltros}
            onClick={() => {
              clearFilter();
              setTimeout(function () {
                clearFilter();
              }, 100);
            }}
          />
          <FilterButton
            disabled={supervisorProduto && !pdvSelected}
            onClick={() => setOpenFilters(!openNewCall)}
          />
        </Styles.RowAlign>
      </Styles.RowSpace>
      {isLoadingAtendimentos === false &&
      isFetched &&
      atendimentos?.length > 0 ? (
        <Styles.TableHeader mg={atendimentos?.length > 3 ? 44 : 32}>
          <Styles.Cell>
            <Styles.HeaderText>Visitante</Styles.HeaderText>
          </Styles.Cell>
          <Styles.Cell>
            <Styles.HeaderText>Corretor</Styles.HeaderText>
          </Styles.Cell>
          <Styles.Cell>
            <Styles.HeaderText>Tipo de visita</Styles.HeaderText>
          </Styles.Cell>
          <Styles.Row>
            <Styles.Cell>
              <Styles.HeaderText>Data</Styles.HeaderText>
            </Styles.Cell>
            <Styles.CellSmall width={32}>
              <Styles.HeaderText>Ação</Styles.HeaderText>
            </Styles.CellSmall>
          </Styles.Row>
        </Styles.TableHeader>
      ) : null}
      <Styles.Body>
        {isLoadingAtendimentos === false &&
        isFetched &&
        Array.isArray(atendimentos) &&
        atendimentos.length > 0 ? (
          <>
            <Styles.Table>
              {atendimentos?.map((item: any) => (
                <TableItem
                  key={item.id}
                  data={item}
                  refetch={() => getFilter()}
                />
              ))}
            </Styles.Table>
          </>
        ) : isLoadingAtendimentos ? (
          <>
            <Skeleton
              variant="rounded"
              width="100%"
              height={40}
              style={{ marginTop: 8 }}
            />
            {useRepetirComponente(
              <Skeleton
                variant="rounded"
                width="100%"
                height={80}
                style={{ marginTop: 8 }}
              />,
              3
            )}
          </>
        ) : (
          <Message text="Nenhum registro encontrado" />
        )}
      </Styles.Body>
      <Styles.ContainerPagination>
        <ThemeProvider theme={theme}>
          <Pagination
            count={totalPaginas}
            page={paginaAtual || 1}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
          />
        </ThemeProvider>
      </Styles.ContainerPagination>

      <Drawer
        elevation={0}
        anchor="right"
        open={openFilters}
        onClose={() => setOpenFilters(!openFilters)}
        BackdropProps={{
          style: {
            backgroundColor: "#66666620",
          },
        }}
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            display: "flex",
          },
        }}
      >
        <Filters
          onClickFilter={(item) => handleGetFilter(item)}
          loading={isLoadingAtendimentos}
        />
      </Drawer>
      <Modal open={openNewCall} onClose={() => setOpenNewCall(false)}>
        <FormNovoAtendimento
          refresh={() => getFilter()}
          allFields
          closeModal={() => setOpenNewCall(false)}
          idCorretor={null}
          nomeLead={null}
        />
      </Modal>
    </Styles.Container>
  );
};

export default completedCalls;
